var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "h1",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c("span", { staticStyle: { "margin-right": "20px" } }, [
            _vm._v("审批类型：")
          ]),
          _c(
            "el-radio-group",
            {
              on: { input: _vm.handleFlowTypeChange },
              model: {
                value: _vm.flowType,
                callback: function($$v) {
                  _vm.flowType = $$v
                },
                expression: "flowType"
              }
            },
            [
              _c("el-radio", { attrs: { label: 1 } }, [_vm._v("会审")]),
              _c("el-radio", { attrs: { label: 2 } }, [_vm._v("顺序审")])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-timeline",
        _vm._l(_vm.menbers, function(item, i) {
          return _c(
            "el-timeline-item",
            {
              key: i,
              attrs: {
                timestamp: _vm.flowType == 1 ? "会审" : "顺序" + (i + 1),
                placement: "top"
              }
            },
            [
              _c(
                "el-card",
                { staticClass: "card-sty" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (_vm.flowType == 1 && item.menber.length < 6) ||
                            (_vm.flowType == 2 && item.menber.length == 0),
                          expression:
                            "(flowType == 1 && item.menber.length < 6) || (flowType == 2 && item.menber.length == 0)"
                        }
                      ],
                      on: {
                        click: function($event) {
                          return _vm.chooseMenber({
                            index: i,
                            isManager: false,
                            flowType: _vm.flowType
                          })
                        }
                      }
                    },
                    [_vm._v("添加审批人")]
                  ),
                  _c(
                    "div",
                    { staticClass: "men-box" },
                    _vm._l(item.menber, function(user) {
                      return _c(
                        "p",
                        { key: user.emplId, staticClass: "men-item" },
                        [
                          _c("img", {
                            attrs: {
                              src: "/images/web/p-default.png",
                              width: "50px",
                              height: "50px",
                              alt: ""
                            }
                          }),
                          _c("span", [_vm._v(_vm._s(user.name))]),
                          _c("span", {
                            staticClass: "item-close close_icon",
                            on: {
                              click: function($event) {
                                return _vm.delUser(i, user)
                              }
                            }
                          })
                        ]
                      )
                    }),
                    0
                  ),
                  _c("p", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.menbers.length > 1,
                        expression: "menbers.length > 1"
                      }
                    ],
                    staticClass: "close-icon close_icon",
                    on: {
                      click: function($event) {
                        return _vm.$emit("delLeven", i)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.flowType == 2,
              expression: "flowType == 2"
            }
          ],
          on: { click: _vm.addLeven }
        },
        [_vm._v("添加审批层级")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e52eb5f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e52eb5f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/components/dingTalkuse/selfSelection.vue
// module id = NOJw
// module chunks = 2 3 6 8 100 230